import React from "react";
import MerchantLayout from "src/components/Layouts/MerchantLayout";
import { useNavigate } from "react-router-dom";
import Card from "src/components/Cards/card";
import { NormalText } from "src/components/styled/text.styled";
import { Button } from "src/components/styled/button.styled";
import TextField from "src/components/Inputs/TextField";
import Dropdown from "src/components/Inputs/Dropdown";
import { Stack, Grid } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import { CreateTableTypeProps, createNewTableType } from "src/redux/tabletype";
import useRedux from "src/redux/useRedux";
import CheckPermission from "src/helper/checkPermission";

const TableTypeForm = () => {
  const navigate = useNavigate();
  const [isSubmit, setIsSubmit] = React.useState(false);
  const { thunkDispatch } = useRedux();
  const [payload, setPayload] = React.useState<CreateTableTypeProps>({
    name: "",
    maximum_table_count: 0,
    minimum_table_count: 0,
  });

  const handleSubmit = () => {
    setIsSubmit(true);
    if (
      payload.name &&
      payload.minimum_table_count > 0 &&
      payload.maximum_table_count > 0
    ) {
      thunkDispatch(createNewTableType(payload))
        .unwrap()
        .then((res) => {
          if (res && res.status === "success") {
            toast.success("Berhasil menambahkan tipe meja");
            setTimeout(() => {
              navigate("/stores/tabletype/list");
            }, 1500);
          } else {
            toast.warning(res?.error.response.data.message);
          }
        });
    } else {
      toast.warning("Silakan cek kembali inputan anda!");
    }
  };

  return (
    <MerchantLayout>
      <ToastContainer />
      <Card>
        <NormalText fontWeight="bold" fontSize="20px" margin="0 0 20px 0">
          Tambah Tipe Meja
        </NormalText>
        <Dropdown
          label={"Tipe"}
          validationType={isSubmit && !payload.name ? "ERROR" : ""}
          validationText={"Tipe meja wajib diisi"}
          isRequired
          options={[
            { label: "Small", value: "Small" },
            { label: "Medium", value: "Medium" },
            { label: "Large", value: "Large" },
          ]}
          value={payload.name}
          onChange={(value: any) => {
            setPayload({ ...payload, name: value });
          }}
        />
        <NormalText fontSize="13px">Jumlah Orang</NormalText>
        <Grid container spacing={1} alignItems={"center"}>
          <Grid item md={2}>
            <TextField
              isRequired
              validationText={
                isSubmit && payload.minimum_table_count <= 0
                  ? "Total minimal wajib diisi"
                  : ""
              }
              validationType={
                isSubmit && payload.minimum_table_count <= 0 ? "ERROR" : ""
              }
              value={payload.minimum_table_count}
              minLength={1}
              type={"number"}
              onChange={(e: any) => {
                setPayload({
                  ...payload,
                  minimum_table_count: Number(e.target.value),
                });
              }}
            ></TextField>
          </Grid>
          <Grid item md={1} textAlign={"center"}>
            Sampai
          </Grid>
          <Grid item md={2}>
            <TextField
              isRequired
              validationText={
                isSubmit && payload.maximum_table_count <= 0
                  ? "Total maksimal wajib diisi"
                  : ""
              }
              validationType={
                isSubmit && payload.maximum_table_count <= 0 ? "ERROR" : ""
              }
              value={payload.maximum_table_count}
              minLength={1}
              type={"number"}
              onChange={(e: any) => {
                setPayload({
                  ...payload,
                  maximum_table_count: Number(e.target.value),
                });
              }}
            ></TextField>
          </Grid>
        </Grid>
        <Stack direction={"row"} spacing={2} margin={"20px 0 20px 0"}>
          <Button
            variant="danger"
            onClick={() => navigate("/stores/tabletype/list")}
          >
            Batal
          </Button>
          {CheckPermission('Table Type', 'is_add') && (
            <Button variant="primary" onClick={() => handleSubmit()}>
              Simpan
            </Button>
          )}
        </Stack>
      </Card>
    </MerchantLayout>
  );
};

export default TableTypeForm;
